import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper, AppBar } from '@mui/material';
import WorkerList from './WorkerList';
import AnalyticsDashboard from './AnalyticsDashboard';
import PayrollTab from './PayrollTab';
import AttendanceTab from './AttendanceTab';
import TasksTab from './TasksTab';
import LeaveTab from './LeaveTab';
import PerformanceTab from './PerformanceTab';
import DocumentsTab from './DocumentsTab';
import NotificationsPanel from './NotificationsPanel';
import ShiftSchedulingTab from './ShiftSchedulingTab';
import TrainingTab from './TrainingTab';
import DisciplinaryTab from './DisciplinaryTab';
import RecruitmentTab from './RecruitmentTab';
import AdvancePayTab from './AdvancePayTab';

interface WorkerManagementProps {
  farmId: string;
}

const tabLabels = [
  'Directory',
  'Analytics',
  'Shifts',
  'Attendance',
  'Tasks',
  'Leave',
  'Payroll',
  'Advance Pay',
  'Training',
  'Disciplinary',
  'Performance',
  'Recruitment',
  'Documents',
  'Notifications'
];

const WorkerManagement: React.FC<WorkerManagementProps> = ({ farmId }) => {
  const [tab, setTab] = useState(0);

  return (
    <Paper elevation={3} sx={{ p: 0, minHeight: '80vh', borderRadius: 3 }}>
      <AppBar position="static" color="default" elevation={0} sx={{ borderRadius: '12px 12px 0 0' }}>
        <Tabs
          value={tab}
          onChange={(_e, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ px: 2 }}
        >
          {tabLabels.map((label) => (
            <Tab key={label} label={label} sx={{ fontWeight: 600 }} />
          ))}
        </Tabs>
      </AppBar>
      <Box sx={{ p: 3 }}>
        {tab === 0 && <WorkerList farmId={farmId} />}
        {tab === 1 && <AnalyticsDashboard farmId={farmId} />}
        {tab === 2 && <ShiftSchedulingTab farmId={farmId} />}
        {tab === 3 && <AttendanceTab farmId={farmId} />}
        {tab === 4 && <TasksTab farmId={farmId} />}
        {tab === 5 && <LeaveTab farmId={farmId} />}
        {tab === 6 && <PayrollTab farmId={farmId} />}
        {tab === 7 && <AdvancePayTab farmId={farmId} />}
        {tab === 8 && <TrainingTab farmId={farmId} />}
        {tab === 9 && <DisciplinaryTab farmId={farmId} />}
        {tab === 10 && <PerformanceTab farmId={farmId} />}
        {tab === 11 && <RecruitmentTab farmId={farmId} />}
        {tab === 12 && <DocumentsTab farmId={farmId} />}
        {tab === 13 && <NotificationsPanel farmId={farmId} />}
      </Box>
    </Paper>
  );
};

export default WorkerManagement;
